module.exports = {
    BASE_URL: `${process.env.REACT_APP_API || ''}/SupportSrv/SupportSrv.svc/Support`,
    WEB_CATALOG: process.env.REACT_APP_WEB_CATALOG
}
